<template>
  <div class="ShowEmoji">
    <Emoji />
    <div class="EmojiList">
      <Emoji
        v-for="(name, index) in emojiList"
        :key="index"
        :name="name"
        @click.native="popImoji(name)"
      />
    </div>
  </div>
</template>
<script>
import Emoji from "@/components/svg/Emoji";
import config from "@/config";
import server from "@/server";

export default {
  data: () => {
    return {
      emojiList: config.emojiList,
      disableClick: false
    };
  },
  methods: {
    popImoji(emojiName) {
      if (this.disableClick) return;
      server.popEmoji(emojiName);
      this.disableClick = true;
      setTimeout(() => {
        this.disableClick = false;
      }, 300);
    }
  },
  components: {
    Emoji
  }
};
</script>
